import React, { useContext, useEffect, useState } from 'react'
import { Box, Chip, CircularProgress, Grid, MenuItem, Paper, IconButton, InputAdornment , Typography} from '@mui/material'
import { Input, Select, TextField } from '@mui/material';
import ApiService from '../../functions/apiService';
import { useSnackbar } from 'notistack';
import AuthContext from '../../context/AuthContext';
import ManagementHeaderNav from '../../components/HeadersNav/ManagementHeaderNav';
import { useDispatch, useSelector } from 'react-redux';
import { setFunctionListDDL } from '../../store/ddlReducer';
import { forEach, reverse } from 'lodash';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import SearchIcon from "@mui/icons-material/Search";
import { MyTeamTable, MyTeamTableCard } from '../../components/MyTeam/MyTeamTable';
import moment from 'moment';
import { toast } from 'react-toastify';

export default function Members() {
  const { permission, pagesName, pages } = useContext(AuthContext);
  const dispatch = useDispatch();
  // const { enqueueSnackbar } = useSnackbar();
  const [sortColumn, setSortColumn] = useState();
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState('FIRE');
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [selectedTab, setSelectedTab] = useState("Active Members");
  const filteredRows = rows.filter(row => row.name === selectedTab);
  const [view, setView] = useState(1);
  const [searchItem, setSearchItem] = useState("");
  const [length, setLength] = useState(0);
  const [show2, setShow2] = useState(false);
  const handleShow = () => setShow2(true);

  let groupName = Object.keys(pagesName).includes("GROUP_HEADER_TEXT")
    ? pagesName.GROUP_HEADER_TEXT
    : "Group";

  const [columns, setColumns] = useState([
    {
      field: 'Effective_Date',
      headerName: 'Effective_Date',
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        return moment(params?.row?.Effective_Date).format('MM/DD/YYYY');
      }
    },
    {
      field: 'Emp_Code', headerName: 'ID', flex: 1, minWidth: 70
    },
    {
      field: 'User_id', headerName: 'User ID', flex: 1, minWidth: 100
      , valueGetter: (params) => params.row.employee?.User_id
    },
    {
      field: 'fullName', headerName: 'Name', flex: 1, minWidth: 200
      , valueGetter: (params) => (params.row.EA_Rank) ? params.row.EA_Rank + ' ' + params.row.employee?.fullName : params.row.employee?.fullName
    },
    {
      field: 'Unit_Number', headerName: 'Unit', flex: 1, minWidth: 120
      , valueGetter: (params) => params.row.employee?.Unit_Number
    },
    {
      field: 'Badge_Number', headerName: 'Badge', flex: 1, minWidth: 120
      , valueGetter: (params) => params.row.employee?.Badge_Number
    },
    {
      field: 'Hire_date',
      headerName: 'Hire Date',
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => {
        return moment(params?.row?.employee?.Hire_date).format('MM/DD/YYYY');
      }
    },
    {
      field: 'EHd_Seniority',
      headerName: 'Snrty',
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => params.row.employee?.EHd_Seniority
    },
    {
      field: 'GroupName',
      headerName: groupName,
      flex: 0,
      minWidth: 140,
    },
    {
      field: 'StationName',
      headerName: 'Assignment',
      minWidth: 120,
      flex: 1

    },
    {
      field: 'PositionName',
      headerName: 'Position',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'Primary_phone',
      headerName: 'Phone',
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => params.row.employee?.Primary_phone
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
      minWidth: 250,
      valueGetter: (params) => params.row.employee?.email
    },
    {
      field: 'Do_Not_Call',
      headerName: 'DNC',
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => params.row.employee?.Do_Not_Call == 1 ? 'Yes' : 'No'
    },
    {
      field: 'StateName',
      headerName: 'Status',
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Chip style={{ width: '90px' }}
            color={(params.row.EA_Status == 'A' && params.row.employee.Hash_Expire != null) ? 'DarkGreen' : 'lightRed'}
            label={params.row.StateName == 'D' ? "Deleted" : params.row.StateName}
          />
        );
      }
    },
  ]);

  const columnsCard = ["Hire Date", "Unit", "Badge", "Seniority", "Group", "Assignment", "Position", "Email", "Phone", "DNC", "Access", "Expires",]

  useEffect(() => {
    rows.forEach((data) => {
      data.employees.map((i) => {
        setData(i.employee.Functional_Department)
      })
    });
  }, [rows]);

  const filteredColumns = data === 'FH247' ? columns.filter(col => col.field !== 'Primary_phone') : columns;
  const filteredColumnsCard = data === 'FH247' ? columnsCard.filter(col => col !== 'Phone') : columnsCard;

  let FunctionListDDL = useSelector((state) => { return state.ddlReducer.FunctionListDDL; });

  const loadData = (search = filter) => {

     const typeParam = search === 'ADMIN' ? 'FH247' : search;
    
    setLoading(true);
    ApiService.get('/getAllEmployee', { type: typeParam }, 'getAllEmployee')
      .then(({ data }) => {
        const sortedData = data?.data.sort((a, b) => {
          if (a.EA_Status < b.EA_Status) return -1;
          if (a.EA_Status > b.EA_Status) return 1;
          return 0;
        });

        setRows(sortedData);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e.data.message)
        // enqueueSnackbar('Error', { variant: 'error' });
      });
  };

  const loadDDL = () => {
    ApiService.get("/getFunctionListDDL").then(({ data }) => {
      dispatch(setFunctionListDDL(data));
    });
  };

  useEffect(() => {
    if (permission && permission.includes('Emp_Auth') && permission.includes('Pass_Auth')) {
      setColumns(pre => {

        if (!pre.find(i => i.field == 'Access')) {
          return [...pre, {
            field: 'Access', headerName: 'Access', flex: 1, minWidth: 120
            , valueGetter: (params) => ' '
          }, {
            field: 'Expires', headerName: 'Expires', flex: 1, minWidth: 120
            ,
            valueGetter: (params) => {
              return params.row.employee?.Hash_Expire ? moment(params.row.employee?.Hash_Expire).format('MM/DD/YYYY') : '';
            }
          }];
        } else {
          return pre;
        }
      })
    }
    loadData(filter);
    loadDDL();
  }, [])

  const handleSortModelChange = React.useCallback((sortModel) => {
    setSortColumn(sortModel[0])
  }, []);

  const setFilterFunction = (value) => {
    setFilter(value)
    loadData(value)
    setSelectedTab("Active Members")
  }

  const filteredEmployees = filteredRows
    .map(group => ({
      ...group,
      employees: group.employees.filter(emp =>
        emp.employee?.fullName?.toLowerCase().includes(searchItem.toLowerCase())
      )
    }))
    .filter(group => group.employees.length > 0);

  const addEmployee = () => {
    window.open("/firehouse/employee", "_blank");
  };

  const getEmployeeCount = (status) => {
    const category = rows.find(row => row.name === status);
    return category ? category.employees.length : 0;
  };


  return (<>
    {/* <ManagementHeaderNav /> */}
    {
      loading && <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
        <CircularProgress />
      </Box>
    }
    {
      !loading && <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
        <Grid item xs={12}>
          <Paper elevation={0} className='my-3'>
            <Box sx={{ maxWidth: '93vw', overflowX: 'auto', background: '#FFF' }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={view == 1 ? 6 : 3.4} className='mx-4 mt-3'>
                  <Typography variant="h5">Members</Typography>
                </Grid>

                <Grid items xs={12} sm={12} md={2}>
                  <div style={{marginTop:'18px'}}>
                    <TextField
                      select size='small'
                      onChange={(e) => setFilterFunction(e.target.value)}
                      placeholder='All'
                      className='mt-0 w-100' color='secondary' variant="outlined"
											label={FunctionListDDL.find(a => a.SO_Value == filter)?.SO_Desc}
                      InputProps={{
                        sx: {
                          height: '48px',
                          fontSize: '14px'
                        }
                      }}
                      InputLabelProps={{
                        sx: {
                          marginTop: '4px',
                          fontSize: '14px'
                        },
                      }}
                    >
                      {FunctionListDDL.map(i =>
                        <MenuItem
                          value={i.SO_Value} key={i.SO_Value}>{i.SO_Desc}
                        </MenuItem>)}
                    </TextField>
                  </div>
                </Grid>

                <Grid item xs={12} sm={12} md={2}>
                  <TextField
                    variant="outlined"
                    placeholder="Search by Name"
                    value={searchItem}
                    onChange={(e) => setSearchItem(e.target.value)}
                    className="w-100"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                      sx: {
                        height: '48px',
                        fontSize: '14px',
                        marginTop: '10px',
                        marginRight: '10px',
                      },
                    }}
                  />
                </Grid>

                {pages.includes('V3_SENIORITY_FORCE_UPDATE') && view == 2 &&
                  <Grid item xs={6} sm={6} md={1.6}>
                    <ButtonTheme
                      color='primary'
                      style={{ marginTop: "16px" }}
                      onClick={handleShow}
                    >Refresh Seniority
                    </ButtonTheme>
                  </Grid>
                }

                {view === 2 &&
                  <Grid item xs={6} sm={6} md={1}>
                    <ButtonTheme
                      color='primary'
                      style={{ marginTop: "16px" }}
                      onClick={addEmployee}
                    >Add New
                    </ButtonTheme>
                  </Grid>
                }
              
                <Grid item xs={6} sm={6} md={1}>
                  <div
                    style={{
                      height: "48px",
                      border: "1px solid #EAECF0",
                      borderRadius: "8px",
                      marginLeft: "10px",
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "48px",
                        height: "48px",
                        borderRight: "1px solid #EAECF0",
                        cursor: "pointer",
                      }}
                      onClick={() => setView(1)}
                    >
                      <img
                        src={view === 1 ? "/images/listview.svg" : "/images/list-empty.svg"}
                        height="20px"
                        width="20px"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "48px",
                        height: "48px",
                        cursor: "pointer",
                      }}
                      onClick={() => setView(2)}
                    >
                      <img
                        src={view === 1 ? "/images/card-empty.svg" : "/images/card.svg"}
                        height="22px"
                        width="22px"
                      />
                    </div>
                  </div>
                </Grid>
                
              </Grid>

              <Grid container spacing={1}>
                <Grid items xs={12} sm={12} md={12}>
                  <div className="mx-4 mb-2" style={{ display: 'flex'  , marginTop:'30px'}}>
                    {rows?.map((data) =>
                    (
                      <div className={selectedTab == data.name ? 'tab-active mx-1' : 'tab-white mx-1'}
                        onClick={() => setSelectedTab(data.name)}>
                        {data.name === 'Active Members'
                          ? 'Active'
                          : data.name === 'Sick/Injured/Military etc'
                            ? 'Sick'
                            : data.name === 'Retired Members'
                              ? 'Retirees'
                              : data.name === 'Open Positions'
                                ? 'Open Positions'
                                : data.name} ({getEmployeeCount(data.name)})
                      </div>
                    )
                    )}
                  </div>
                </Grid>
              </Grid>

              {view === 1 ?
                (
                  <div>
                    {filteredEmployees.map(row => (
                      <div key={row.name}>
                        <MyTeamTable row={row} columns={filteredColumns} filter={filter} loadData={loadData} />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>
                    {filteredEmployees.map(row => (
                      <div key={row.name}>
                        <MyTeamTableCard row={row} columns={filteredColumnsCard} filter={filter} loadData={loadData} show={show2} setShow={setShow2} />
                      </div>
                    ))}
                  </div>
                )}

              <div className='mt-3'>
                {(filteredRows.length === 0 || filteredEmployees.length === 0) &&
                  <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 550 }}>
                    <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                    <span className='mt-4' style={{ color: '#555555' }}>
                      No member found
                    </span>
                  </div>
                }
              </div>
            </Box>
          </Paper>
        </Grid>
      </Grid >
    }
  </>)

}
